import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Decides on the /auth/me user: after a reload the stored one is the sign-in payload until /auth/me answers. */
export const pharmacyAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const check = () => (auth.canManageMembers() ? true : router.createUrlTree(['/home']));
  const pending = auth.pendingUserRefresh();
  return pending ? pending.then(check, check) : check();
};
